export default __webpack_public_path__ + "static/media/decisionSpeed.8b96576e.svg";